import React from 'react';
import { B1, Text32 } from '@nile/components';
import { withRouter } from 'react-router-dom';
import envConfig from '@nile/home/src/Config/env';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import queryString from 'query-string';

const ErrorPageContent = styled.div`
  display: flex;
  .text {
    line-height: 60px;
  }
  .description {
    max-width: 400px;
    padding-right: 80px;
  }
`;

const ErrorPageWrapper = styled.div`
  height: 100vh;
  background-color: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .jc-ctr {
    justify-content: center;
  }
`;

const Image = styled.div`
  background-image: ${(props) => props.url};
  background-size: 100%;
  background-repeat: no-repeat;
  height: ${(props) => props.height || '170px'};
  width: ${(props) => props.width || '200px'};
`;

const ShowErrorPage = (props) => {
  const processedToken = queryString.parse(props.location.search).code;
  const errorMessage = 'app.integration.error.' + processedToken;
  return (
    <ErrorPageWrapper>
      <div className="errorContainer">
        <ErrorPageContent>
          <div className="flex col jc-ctr mr30">
            <Text32 className="text">
              <B1>
                <FormattedMessage id={errorMessage} />
              </B1>
            </Text32>
          </div>
          <Image
            url={`url(${envConfig.imageRoot}svg/AgentError.svg)`}
            height="220px"
          />
        </ErrorPageContent>
      </div>
    </ErrorPageWrapper>
  );
};

export default withRouter(ShowErrorPage);
